"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createValues = _interopRequireDefault(require("./createValues"));

var _plain = _interopRequireDefault(require("./structure/plain"));

var _default = (0, _createValues["default"])(_plain["default"]);

exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/values.js
 ** module id = 1997
 ** module chunks = 0
 **/